<template>
	<div class="header">
		<SelectChain v-slot="slotProps">
			<BaseButton class="button">
				{{ slotProps.chainDetails.title }}
				<ChevronDownIcon class="icon chevron-down-icon" />
			</BaseButton>
		</SelectChain>

		<BaseButton class="button" @click="copyAddress()">
			<AddressAvatar :address="walletStore.address!" class="avatar" />
			<span>{{ formatAddress(walletStore.address!) }}</span>
		</BaseButton>
	</div>
</template>

<script setup lang="ts">
import { useWalletStore } from '@/stores/useWalletStore';
import { CHAINS } from '@/constants';
import { useTelegram } from '@/composables/useTelegram';
import { formatAddress } from '@/utils';
import SelectChain from '@/components/SelectChain.vue';
import AddressAvatar from '@/components/AddressAvatar.vue';
import ChevronDownIcon from '@/assets/icons/chevron-down.svg?component';
import BaseButton from '@/components/ui/BaseButton.vue';

const walletStore = useWalletStore();
const { telegram } = useTelegram();

const copyAddress = () => {
	navigator.clipboard.writeText(walletStore.address!);
	telegram.WebApp.showAlert('Address copied to clipboard');
};

const options = Object.values(CHAINS);
</script>

<style scoped>
.header {
	display: flex;
	width: 100%;
	justify-content: space-between;
	/* display: flex; */
	/* justify-content: space-between; */
}

.avatar {
	border-radius: 50%;
	height: var(--size-l);
	margin-right: var(--size-xxs);
}

.button {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 6px 12px;
	gap: 8px;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.1) -1.65%,
		rgba(185, 218, 255, 0.1) 52.48%,
		rgba(2, 122, 255, 0.1) 104.15%
	);
	box-shadow: 0px 0px 25px rgba(2, 122, 255, 0.15);
	border-radius: 16px;

	border: 1px solid rgba(2, 122, 255, 0.1);

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 120%;

	color: rgba(255, 255, 255, 0.8);
}

.chevron-down-icon {
	stroke: rgba(75, 86, 117, 1);
}
</style>
